/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line react/no-direct-mutation-state
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScrollContainer from 'react-indiana-drag-scroll';
import Header from './header'
import Menu from './menu'
import Toast from './sub_components/toast'
import BetSlipPopup from './sub_components/betSlipPopup';
import InPlayGame from './sub_components/inPlayGame'
import * as eventService from '../services/eventService'
import * as orderService from '../services/orderService'
import * as binaryService from '../services/binaryService';
import * as dateUtil from '../util/date.util'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import { showBinary, showKabaddi, showElection } from '../configs/casinoShowList';
import { calculateBetExpouser, calculateFancyMktExpouser, calculateFancyMktExpouserDemo } from '../util/expouser.util';

let mBets = []
let formInterval
let socket = null
class InPLay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            games: {},
            filtered_games: {},
            game: {},
            event: {},
            gameCode: "",
            markets: [],
            books: {},
            selected_market: null,
            selcted_bet_option: null,
            evtList: "",
            matched_bet: [],
            unmatched_bet: [],
            selected_list: "matched",
            selected_game_code: null,
            selected_event_code: null,
            filter: "all",
            cktEvents: [],
            socEvents: [],
            tenEvents: [],
            kbdEvents: [],
            binaryEvents: [],
            electEvents: [],
            pinnedEvents: [],
            showToast: false,
            toastMsg: "",
            toastType: "",
            loading: false,
            eventIdList: [],
            loadingBet: false,
            mktFeedBooks: {},
            betLimit: 20,
            betSlipOpen: false,
            matchedBetLoaded: false,
            deactivatMarkets: [],
            deactivatOrders: [],
            evetList: [],
            subscribedMarkets: [],
            betPlaced: false,
            houndEvents: [],
            horsEvents: [],
            allowUpdate: true,
            isLoaded: false,
            // accountData: {},
        };
    }
    componentDidMount() {
        // let accData = JSON.parse(localStorage.getItem("accountData"));
        // if (!!accData && accData.username) {
        // this.setState({ accountData: accData });
        // }
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!!userData && userData.role === 'DemoClient'){
            socket.on("demo_room", async (data) => {
                let msg = JSON.parse(data);
                if (!!msg.command && ["MARKET_RESULT","MARKET_VOID"].includes(msg.command)) {
                    let demoIdSsData = this.state.matched_bet;
                    let betindex = -1;
                    
                    for(let i=0; i<demoIdSsData.length;i++){
                        if(demoIdSsData[i].marketId === msg.payload.message.marketId){
                            betindex = i;
                            break;
                        }
                    } 

                    if(betindex >-1){
                        demoIdSsData.splice(betindex,1);
                        this.setState({matched_bet:demoIdSsData})
                    }

                    // msg.payload
                }
            })
        }
    }
    componentWillUnmount() {
        if(!!this.props.socket){
            this.props.socket.off("demo_room");
        }
    }

    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.state.mktFeedBooks = feedBooks
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    hidePopup() {
        this.setState({ betSlipOpen: false })
    }
    async getEvtData(userEventCktData, userEventSocData, userEventTenData, userEventKbdData, userEventElectData, userEventHorseData, userEventHoundData, userEventBinaryData) {
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        if (!userEventCktData && !userEventSocData && !userEventTenData && !userEventKbdData && !userEventElectData && !userEventBinaryData) {
            return false
        }
        let userEventData = userEventCktData.concat(userEventSocData, userEventTenData, userEventKbdData, userEventElectData, userEventHorseData, userEventHoundData, userEventBinaryData)
        let events = []
        !!userEventData && userEventData.length > 0 && userEventData.forEach((mkt, i) => {
            if (!mkt || !mkt.catalogue || !mkt.catalogue.inPlay) {
                return false
            }
            let eventIndex = events.findIndex(x => x.id === mkt.event.id)
            let market = { ...mkt.catalogue, ...mkt.marketCondition }
            market.metadata = mkt.metadata
            market.marketBook = !!market.metadata && !!market.metadata.book ? market.metadata.book : {}
            market.marketId = mkt.catalogue.marketId
            if (mkt.eventType.id === "300") {
                market.displayMarketNameTime = mkt.displayMarketNameTime
                market.eventId = mkt.eventId
                market.eventName = mkt.eventName
                market.competitionName = mkt.competitionName
            }
            if (Object.keys(market.marketBook).length === 0) {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }], "lay": [{ "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            if (market.provider !== "BETHUBS") {
                if (!market.marketBook || mkt.status === "CLOSED" || market.marketBook.status === "CLOSED" || market.marketBook.status === "INACTIVE" || !market.marketBook.runners || (market.provider === "MTQ" ? market.marketBook.runners.length < 1 : market.marketBook.runners.length < 2)) {
                    return false
                }
            }
            market.marketId = mkt.catalogue.marketId
            if (eventIndex === -1) {
                let evt = mkt.event
                evt.status = market.status
                evt.eventTypeId = mkt.eventType.id
                evt.eventType = mkt.eventType.name
                evt.competitionId = mkt.competition.id
                evt.compititionName = mkt.competition.name
                evt.markets = [market]
                evt.evtMeta = market.metadata.eventMeta
                events.push(evt)
            } else {
                events[eventIndex].markets.push(market)
            }
        })
        events = events.filter((evet, i) => {
            let market = evet.markets.filter((mkt, i) => {
                return mkt.marketType === "MATCH_ODDS"
            })
            if (market.length === 0) {
                market = evet.markets.filter((mkt, i) => {
                    return mkt.marketType === "BM_MATCH_ODDS"
                })
            }
            if (market.length === 0) {
                market = evet.markets
            }
            return market
        })
        events = events.sort((vote1, vote2) => {
            if (vote1.isInplay > vote2.isInplay) return -1;
            if (vote1.isInplay < vote2.isInplay) return 1;
            if (new Date(vote1.openDate) > new Date(vote2.openDate)) return 1;
            if (new Date(vote1.openDate) < new Date(vote2.openDate)) return -1;
            if (vote1.name > vote2.name) return 1;
            if (vote1.name < vote2.name) return -1;
            return 0;
        });
        events.forEach((evt, i) => {
            var moPos = evt.markets.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
            if (moPos !== -1) {
                let mom = [evt.markets[moPos]]
                evt.markets.splice(moPos, 1)
                events[i].markets = mom.concat(evt.markets)
            }
        })
        let evtList = events.map(ev => ev.id)
        if (evtList.length > 0) {
            evtList = evtList.sort();
        }
        evtList = evtList.toString()

        // if (!this.state.matchedBetLoaded) {
        if (this.state.evtList !== evtList && !this.state.isLoaded) {
            setTimeout(async () => {
                const accData = JSON.parse(localStorage.getItem("accountData"));
                if ((!!accData && Object.keys(accData).length > 0)) {
                    await eventService.getMatchedBets({ "id": evtList }).then((res) => {
                        if (!!res && res.isSuccess) {
                            mBets = []
                            let userData = localStorage.getItem("tokenData")
                            userData = JSON.parse(userData)
                            if(!!userData && userData.role === 'DemoClient'){
                                let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                                demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : null;
                                if(!!demoIdSsData){
                                    Object.keys(demoIdSsData).forEach((itmm)=>{
                                        demoIdSsData[itmm].forEach((itm)=>{
                                            mBets.push(itm);
                                        })
                                    })
                                    // mBets = Object.values(demoIdSsData)
                                }
                            } else {
                                res.items.forEach((bet) => {
                                    let event_id = bet.eventId
                                    let event = events.filter((ev) => { return ev.id === event_id })[0]
                                    bet.eventName = event.name
                                    let market = event.markets.filter((mk) => { return mk.marketId === bet.marketId })[0]
                                    if (!market) {
                                        return false
                                    }
                                    bet.marketType = market.marketType
                                    // let runner = market.runners.filter((rn) => { return rn.id === bet.runnerId })[0]
                                    // bet.runnerName = runner.name
                                    if (bet.eventTypeId === '300') {
                                        bet.market_time = dateUtil.getBinaryMarketDisplayName(bet.marketName)
                                    }
                                    mBets.push(bet)
                                })
                            }
                        }
                    })
                }

                // mBets = mBets.reverse()
                this.setState({ matched_bet: [], evtList: "", isLoaded: true },
                    () => {
                        this.setState({ matched_bet: mBets, evtList: evtList, matchedBetLoaded: true })
                    }
                )

            }, 300)
        }
        let cktEvents = events.filter((et) => {
            return et.eventTypeId === "4"
        })

        let socEvents = events.filter((et) => {
            return et.eventTypeId === "1"
        })
        let tenEvents = events.filter((et) => {
            return et.eventTypeId === "2"
        })
        let kbdEvents = !!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true ? events.filter((et) => {
            return et.eventTypeId === "400"
        }) : [];
        let electEvents = !!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true ? events.filter((et) => {
            return et.eventTypeId === "500"
        }) : [];
        let binaryEvents = []
        if (showBinary) {
            binaryEvents = events.filter((et) => {
                return et.eventTypeId === "300"
            })
        }
        userEventHorseData = userEventHorseData.sort(function (x, y) { return (new Date(x.catalogue.marketTime).getTime()) - (new Date(y.catalogue.marketTime).getTime()) });
        userEventHoundData = userEventHoundData.sort(function (x, y) { return (new Date(x.catalogue.marketTime).getTime()) - (new Date(y.catalogue.marketTime).getTime()) });
        userEventHorseData = userEventHorseData.filter((mkt, i) => { return (180000 > (new Date(mkt.catalogue.marketTime).getTime() - new Date().getTime())) })
        userEventHoundData = userEventHoundData.filter((mkt, i) => { return (180000 > (new Date(mkt.catalogue.marketTime).getTime() - new Date().getTime())) })
        let self = this
        this.setState({ cktEvents: cktEvents, socEvents: socEvents, tenEvents: tenEvents, kbdEvents: kbdEvents, electEvents: electEvents, binaryEvents: binaryEvents, allEvents: events }, () => {
            if (this.state.allowUpdate) {
                self.setState({ horsEvents: [], houndEvents: [] }, () => {
                    self.setState({ horsEvents: userEventHorseData, houndEvents: userEventHoundData, allowUpdate: false })
                    setTimeout(() => {
                        self.setState({ allowUpdate: true })
                    }, 60000)
                })
            }
        })
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        this.setState({ pinnedEvents: pinnedEvents, loading: false, eventIdList: evtList }, () => { this.applyFilter() })
    }
    applyFilter(fltr) {
        let filter = !fltr ? this.state.filter : fltr
        this.setState({ filter: filter })
    }
    detectMob() {
        const toMatch = [
            "/Android/i",
            "/webOS/i",
            "/iPhone/i",
            "/iPad/i",
            "/iPod/i",
            "/BlackBerry/i",
            "/Windows Phone/i"
        ];
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }

    addBetBin(bet) {
        this.setState({ loadingBet: true })
        bet.event_name = bet.market.eventName
        bet.competition_Name = bet.market.competitionName
        let betData = JSON.parse(localStorage.getItem("betForm"))
        let body = {
            marketId: bet.marketId,
            placeInstruction: {
                orderType: "LIMIT",
                selectionId: parseFloat(betData.selectionId),
                side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                limitOrder: {
                    size: parseFloat(parseFloat(betData.bid_amount.toString()).toFixed(2)),
                    price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
                    persistenceType: "PERSIST"
                }
            }
        }
        if (!!betData.bid_line && betData.bid_line > 0) {
            body.placeInstruction.selectionId = parseFloat(betData.bid_line)
        }
        binaryService.placeOrder(body).then((res) => {
            if (res.isSuccess !== false && !res.errors) {
                if (!!res.exception && !!res.exception.message) {
                    this.props.notify(res.exception.message, "error")
                } else {
                    this.props.notify("Bet Placed Successfully !", "success")
                    if (!!res.data && Object.keys(res.data).length > 0) {
                        let dat = Object.assign({}, res.data)
                        dat['eventTypeId'] = '300'
                        this.orderPlaced(dat, bet)
                    }
                }
                // setTimeout(() => {
                //     this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
                // }, bet.market.betDelay)
            } else {
                this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
            }
            this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
            this.betFormBin(null, null)
        })
    }

    checkingetzero(txt){
        return txt.toString().length === 1 ? '0' : '';
    }

    addDemoBet(bet, prfdt){
        const crdt = new Date();
        const crdtat = `${crdt.getFullYear()}-${this.checkingetzero(crdt.getMonth())}${crdt.getMonth()}-${this.checkingetzero(crdt.getDate())}${crdt.getDate()}T${this.checkingetzero(crdt.getHours())}${crdt.getHours()}:${this.checkingetzero(crdt.getMinutes())}${crdt.getMinutes()}:${this.checkingetzero(crdt.getSeconds())}${crdt.getSeconds()}Z`;
        let demoExpo = sessionStorage.getItem('demoExpo')
        let totalexpo = 0
            if(!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0){
                demoExpo = JSON.parse(demoExpo);
                totalexpo = (Object.values(demoExpo).reduce((a,v) =>  a = a + v , 0 ))
            }
        let resdata = {
            "provider": bet?.market?.provider,
            "orderId": crdt.getTime(),
            "orderType": "LIMIT",
            "eventId": this.props.match.params.event_id,
            "marketId": bet?.marketId,
            "marketName": bet?.market?.marketName,
            "marketType": bet?.market?.marketType,
            "marketBettingType": bet?.market?.bettingType,
            "side": bet?.bet_for?.toUpperCase(),
            // "runnerId": bet.selectionId,
            // "runnerName": "Papua New Guinea",
            "price": bet?.price,
            "amount": !!bet ? parseInt(bet.bet_amount):0,
            "runnersExposure": {
                // "247649": {
                //     "runnerId": 247649,
                //     "exposure": -100,
                //     "sharingUp": -100,
                //     "sharingMe": 0,
                //     "sharingDown": 0
                // },
                // "2857977": {
                //     "runnerId": 2857977,
                //     "exposure": 8,
                //     "sharingUp": 8,
                //     "sharingMe": 0,
                //     "sharingDown": 0
                // }
            },
            "subscriber": prfdt.userId,
            "baseAmount": bet?.bet_amount,
            "createdAt": crdtat,
            "operatorId": prfdt.operatorId,
            "username": prfdt.username,
            "currency": prfdt.currency,
            "currencyConversion": prfdt.currencyConversion,
            "userId": prfdt.userId
        };
        let btexp = 0;
        if(bet?.market?.bettingType === "LINE"){
            resdata['runnerId'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
            resdata['runnerName'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
            let btarr = [];
            btarr.push(resdata);
            let betexpo = calculateFancyMktExpouserDemo(bet.market, btarr);
            btexp = betexpo.expo;
        } else {

            let betexpo = calculateBetExpouser(bet.market,bet.market.runners,bet?.bet_for?.toLowerCase(),bet.bet_amount,bet.price,true)
            bet?.market?.runners.forEach((itm)=>{
                resdata['runnersExposure'][itm.id] = {};
                resdata['runnersExposure'][itm.id]["runnerId"]= itm.id;
                resdata['runnersExposure'][itm.id]["name"]= itm.name;
                resdata['runnersExposure'][itm.id]["exposure"]= betexpo[itm.id];
                resdata['runnersExposure'][itm.id]["sharingUp"]= 0;
                resdata['runnersExposure'][itm.id]["sharingMe"]= 0;
                resdata['runnersExposure'][itm.id]["sharingDown"]=0;
            })
            resdata['runnerId'] = bet?.selectionId; //resdata['runnersExposure'][bet?.selectionId]["runnerId"];
            resdata['runnerName'] = resdata['runnersExposure'][bet?.selectionId]["name"];
            let expvlarr = Object.values(betexpo)
            btexp = Math.min(...expvlarr);
        }
        // totalexpo = totalexpo + (bet?.market?.bettingType === "LINE" ? 0 : btexp);
        totalexpo = totalexpo + btexp;
        const profData = JSON.parse(localStorage.getItem('profData'));
        let demopl = sessionStorage.getItem('demoPnL')

        let availableBal = profData.balance + totalexpo + (!!demopl ? demopl : 0);
        if(availableBal < 0){
            this.props.notify("Not Enough Balance", "error")
            this.setState({selected_market: "", selcted_bet_option: "", loadingBet: false });
            if(bet?.market?.bettingType === "LINE"){
                // demoExpo[bet?.marketId] = demoExpo[bet?.marketId] - btexp;
                // sessionStorage.setItem('demoExpo',JSON.stringify(demoExpo));
                document.getElementById('btnHdnRecalculateDemoExpo').click();
            }
        } else {
            let res={
                isSuccess: true,
                data: resdata
            }
            this.onOrderPlaced(res);
            // this.setState({ loadingBet: true },()=>{
            //     setTimeout(() => {
            //         // this.setState({ loadingBet: false },()=>{

            //         // })    
            //         this.onOrderPlaced(res);
            //     }, 3000);
            // })
        }
    }


    addBet(bet, event) {
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt.role === 'DemoClient'){
            // debugger;
            this.addDemoBet(bet, prfdt);
        } else {
            this.setState({ loadingBet: true })
            let body = {
                marketId: bet.marketId,
                placeInstruction: {
                    orderType: "LIMIT",
                    selectionId: parseFloat(bet.selectionId),
                    side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                    limitOrder: {
                        size: parseFloat(parseFloat(bet.bet_amount.toString()).toFixed(2)),
                        price: parseFloat(parseFloat(bet.price.toString()).toFixed(2)),
                        persistenceType: "PERSIST"
                    }
                }
            }
            let bettingType = event.markets[0].bettingType
            if (bettingType === "BOOKMAKER") {
                orderService.placeBMOrder(body).then((res) => { this.onOrderPlaced(res) })
            } else if (bettingType === "LINE") {
                orderService.placeLineOrder(body).then((res) => { this.onOrderPlaced(res) })
            } else if (bettingType === "ODDS") {
                orderService.placeOddsOrder(body).then((res) => { this.onOrderPlaced(res) })
            }
            // orderService.placeOrder(body).then((res) => {
            //     if (res.isSuccess !== false && !res.errors) {
            //         if (!!res.exception && !!res.exception.message) {
            //             this.props.notify(res.exception.message, "error")
            //         } else {
            //             this.props.notify("Bet Placed Successfully !", "success")
            //             if (!!res.data && Object.keys(res.data).length > 0) {
            //                 this.orderPlaced(res.data)
            //             }
            //         }
            //     } else {
            //         this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
            //     }
            //     this.setState({ selected_game_code: "", selected_event_code: "", loadingBet: false })
            // })
        }
    }
    onOrderPlaced(res) {
        if (res.isSuccess !== false && !res.errors) {
            if (!!res.exception && !!res.exception.message) {
                this.props.notify(res.exception.message, "error")
            } else {
                this.props.notify("Bet Placed Successfully !", "success")
                if (!!res.data && Object.keys(res.data).length > 0) {
                    this.orderPlaced(res.data)
                }
            }
        } else {
            this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
        }
        this.setState({ selected_game_code: "", selected_event_code: "", loadingBet: false })
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    betFormBin(market, bet, clicked) {
        if (this.state.loadingBet === true) {
            return false
        }
        this.setState({ selected_game_code: !!market ? "300" : null, selected_event_code: !!market ? market.eventId : null }, () => {
            if (clicked) {
                if (window.innerWidth > 767) {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtns").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtns").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(0, window.scrollY + 70)
                    }
                } else {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtnsMob").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(window.scrollY, window.scrollY + 235)
                    }
                    // let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    // let yOffset = (screenHeight / 2) - window.pageYOffset + 235
                    // myBetForm = myBetForm + 235
                    // if (myBetForm < yOffset) {
                    //     window.scrollTo(0, window.scrollY + 235)
                    // } else {
                    //     window.scrollTo(0, window.scrollY)
                    // }
                }
            }
        })
        let self = this
        clearTimeout(formInterval)
        formInterval = setTimeout(() => {
            if (self.state.selected_game_code === "300" && self.state.selected_event_code === market.eventId) {
                self.betFormBin(null, null)
            }
        }, 10000)
    }
    betForm(game_code, event_code, clicked) {
        if (this.state.loadingBet === true) {
            return false
        }
        this.setState({ selected_game_code: game_code, selected_event_code: event_code }, () => {
            if (game_code !== null && event_code !== null && clicked) {
                if (window.innerWidth > 767) {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtns").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtns").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(0, window.scrollY + 70)
                    }
                } else {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtnsMob").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(window.scrollY, window.scrollY + 235)
                    }
                    // let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    // let yOffset = (screenHeight / 2) - window.pageYOffset + 235
                    // myBetForm = myBetForm + 235
                    // if (myBetForm < yOffset) {
                    //     window.scrollTo(0, window.scrollY + 235)
                    // } else {
                    //     window.scrollTo(0, window.scrollY)
                    // }
                }
            }
        })
        let self = this
        clearTimeout(formInterval)
        formInterval = setTimeout(() => {
            if (self.state.selected_game_code === game_code && self.state.selected_event_code === game_code) {
                self.betForm(null, null)
            }
        }, 10000)
    }
    async resultDeclered(type, payload) {
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let matchedBets = this.state.matched_bet
        if (type === "market") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatMarkets.indexOf(bet.marketId) === -1
            })
        } else if (type === "order") {
            if (!!payload && !!payload.orderId) {
                deactivatOrders.push(payload.orderId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatOrders.indexOf(bet.orderId) === -1
            })
        } else if (type === "rollback") {
            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
                deactivatMarkets = deactivatMarkets.splice(index, 1)
                matchedBets = await eventService.getMatchedBets({ "id": this.state.eventIdList.toString() })
                matchedBets = matchedBets.items
                matchedBets = matchedBets.filter((bet) => {
                    return deactivatMarkets.indexOf(bet.marketId) === -1
                })
                matchedBets = matchedBets.filter((bet) => {
                    return deactivatOrders.indexOf(bet.orderId) === -1
                })
            }
        }
        this.setState({ matched_bet: matchedBets, deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders })
    }
    orderPlaced(ord) {
        let res = [ord]
        if (res[0].marketBettingType === "LINE") {
            res[0].runnerName = res[0].marketName
        }
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let data = res.concat(this.state.matched_bet)
        data = data.filter((bet) => {
            return deactivatMarkets.indexOf(bet.marketId) === -1
        })
        data = data.filter((bet) => {
            return deactivatOrders.indexOf(bet.orderId) === -1
        })
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(!!prfdt && prfdt.role === 'DemoClient'){
            let demoIdSsData = sessionStorage.getItem('demoIdSsData');
            demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : {};
            demoIdSsData[this.props.match.params.event_id] = data
            sessionStorage.setItem('demoIdSsData', JSON.stringify(demoIdSsData));
            setTimeout(()=>{
                document.getElementById('btnHdnRecalculateDemoExpo').click();
            },1000)
        }
        this.setState({ matched_bet: data, betPlaced: true })

    }
    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }
    updateSocket(skt) {
        socket = skt
    }
    formatTimeString(time) {
        let hrs = new Date(time).getHours()
        hrs = hrs < 10 ? "0" + hrs : hrs
        let min = new Date(time).getMinutes()
        min = min < 10 ? "0" + min : min
        return hrs + ":" + min
    }
    render() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} updateBetplaceStatus={() => { this.setState({ betPlaced: false }) }} betPlaced={this.state.betPlaced} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSocket={(skt) => { this.updateSocket(skt) }} orderPlaced={(ord) => { this.orderPlaced(ord) }} resultDeclered={(type, payload) => { this.resultDeclered(type, payload) }} getEvtData={(ckt, soc, ten, kbd, elect, hor, hou, bin) => { this.getEvtData(ckt, soc, ten, kbd, elect, hor, hou, bin) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />

                    <div className="col-centersdetails markets">
                        <div className="">
                            <div className="live-match">
                                <div className="sub_path center-box crname">
                                    <p>In-Play</p>
                                </div>
                                <div className="game-wrap col3 mb-0">
                                    <div className="middle-in-play-white-bg inplay-scroll-menu">
                                        <ul className="in-play-top">
                                            <li className="w-10" onClick={() => { this.applyFilter("tv") }} >
                                                <a href="#">
                                                    <span className='sports-icon watchlive'></span>
                                                    <span className="inplay-place">Watch Live</span>
                                                </a>
                                            </li>
                                            <li className="w-10" onClick={() => { this.applyFilter("all") }}>
                                                <a className={this.state.filter === "all" ? "active" : null}>
                                                    <span className='sports-icon allgames'></span>
                                                    <span className="inplay-place">All Games</span>
                                                </a>
                                            </li>
                                            <li className="w-10" onClick={() => { this.applyFilter("4") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.cktEvents.length}</span>
                                                    <span className='sports-icon sportcricket'></span>
                                                    <span className="inplay-place">Cricket</span>
                                                </a>
                                            </li>
                                            <li className="w-10" onClick={() => { this.applyFilter("1") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.socEvents.length}</span>
                                                    <span className='sports-icon sportsoccer'></span>
                                                    <span className="inplay-place">Soccer</span>
                                                </a>
                                            </li>
                                            <li className="w-10" onClick={() => { this.applyFilter("2") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.tenEvents.length}</span>
                                                    <span className='sports-icon sporttennis'></span>
                                                    <span className="inplay-place">Tennis</span>
                                                </a>
                                            </li>
                                            <li className="w-10" onClick={() => { this.applyFilter("7") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.horsEvents.length}</span>
                                                    <span className='sports-icon sporthorse'></span>
                                                    <span className="inplay-place">Horse</span>
                                                </a>
                                            </li>
                                            <li className="w-10" onClick={() => { this.applyFilter("4339") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.houndEvents.length}</span>
                                                    <span className='sports-icon sportgreyhound'></span>
                                                    <span className="inplay-place">GreyHound</span>
                                                </a>
                                            </li>
                                            {!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && <li className="w-10" onClick={() => { this.applyFilter("400") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.kbdEvents.length}</span>
                                                    <span className='sports-icon sportkabaddi'></span>
                                                    <span className="inplay-place">Kabaddi</span>
                                                </a>
                                            </li>}
                                            {!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && <li className="w-10" onClick={() => { this.applyFilter("500") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.electEvents.length}</span>
                                                    <span className="sports-icon sportelection"></span>
                                                    <span className="inplay-place">Election</span>
                                                </a>
                                            </li>}
                                            {showBinary && <li className="w-10" onClick={() => { this.applyFilter("300") }}>
                                                <a href="#">
                                                    <span className="in-play-budge">{this.state.binaryEvents.length}</span>
                                                    <span className='sports-icon sportbinary'></span>
                                                    <span className="inplay-place">Binary</span>
                                                </a>
                                            </li>}
                                            {(!!accData && Object.keys(accData).length > 0) &&
                                                <li className="w-10" onClick={() => { this.applyFilter("multi") }}>
                                                    <a href="#">
                                                        <span className='sports-icon sportmultimarket'></span>
                                                        <span className="inplay-place">Multi Markets</span>
                                                    </a>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="live-match">
                                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "4") && <InPlayGame history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} notify={(msg, type) => { this.props.notify(msg, type) }} filter={this.state.filter} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents} gameCode={"4"} selected_game_code={this.state.selected_game_code} selected_event_code={this.state.selected_event_code} betForm={(game, event, clicked) => { this.betForm(game, event, clicked) }} game={this.state.cktEvents} addBet={(data, event) => { this.addBet(data, event) }} game_name={"Cricket"} togglebetLoader={()=>this.setState({loadingBet: true})} />}
                                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "1") && <InPlayGame history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} notify={(msg, type) => { this.props.notify(msg, type) }} filter={this.state.filter} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents} gameCode={"1"} selected_game_code={this.state.selected_game_code} selected_event_code={this.state.selected_event_code} betForm={(game, event, clicked) => { this.betForm(game, event, clicked) }} game={this.state.socEvents} addBet={(data, event) => { this.addBet(data, event) }} game_name={"Soccer"} togglebetLoader={()=>this.setState({loadingBet: true})} />}
                                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "2") && <InPlayGame history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} notify={(msg, type) => { this.props.notify(msg, type) }} filter={this.state.filter} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents} gameCode={"2"} selected_game_code={this.state.selected_game_code} selected_event_code={this.state.selected_event_code} betForm={(game, event, clicked) => { this.betForm(game, event, clicked) }} game={this.state.tenEvents} addBet={(data, event) => { this.addBet(data, event) }} game_name={"Tennis"} togglebetLoader={()=>this.setState({loadingBet: true})} />}
                                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "7") &&
                                    <div className="horse">
                                        <div className="sub_path center-box">
                                            <p>Horse Racing</p>
                                        </div>
                                        <div className="game-wrap col3  py-1 d-flex">
                                            {this.state.horsEvents.length !== 0 && <span className='upcome'>Coming Up</span>}

                                            {this.state.horsEvents.length === 0 &&
                                                <span style={{ margin: "5px", width: 300 }}>has no live event.</span>
                                            }
                                            <ScrollContainer className="scroll-container" horizontal="true" vertical="false">
                                                <div style={{ whiteSpace: "nowrap" }}>
                                                    <ul className='horsedatahome'>
                                                        {this.state.horsEvents.map((ev, i) => {
                                                            if (this.state.filter === "multi" && this.state.pinnedEvents.indexOf(ev.catalogue.marketId) === -1) {
                                                                return false
                                                            }
                                                            if (this.state.filter === "tv" && ev.metadata.eventMeta.hasTv !== 'true') {
                                                                return false
                                                            }
                                                            return <li>
                                                                <a onClick={() => { this.props.history.push("/event/" + ev.eventType.id + "/" + ev.event.id + "/" + ev.catalogue.marketId) }}>
                                                                    <img src={BASE_IMAGE_PATH + "/casino/banner/images/horse.svg"} className='horsehomeimg'></img>
                                                                    <span className='mr-1'>{this.formatTimeString(ev.catalogue.marketTime)}</span>{ev.event.name}
                                                                </a>
                                                            </li>
                                                        })}
                                                    </ul>
                                                </div>
                                            </ScrollContainer>
                                            {/* <marquee scrollamount="5" behavior="scroll" className="horsemarquee">
                                                <ul className='horsedatahome'>
                                                    {this.state.horsEvents.map((ev, i) => {
                                                        if (this.state.filter === "multi" && this.state.pinnedEvents.indexOf(ev.catalogue.marketId) === -1) {
                                                            return false
                                                        }
                                                        if (this.state.filter === "tv" && ev.metadata.eventMeta.hasTv !== 'true') {
                                                            return false
                                                        }
                                                        return <li>
                                                            <a onClick={() => { this.props.history.push("/event/" + ev.eventType.id + "/" + ev.event.id + "/" + ev.catalogue.marketId) }}>
                                                                <img src={BASE_IMAGE_PATH + "/casino/banner/images/horse.svg"} className='horsehomeimg'></img>
                                                                <span className='mr-1'>{this.formatTimeString(ev.catalogue.marketTime)}</span>{ev.event.name}
                                                            </a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </marquee> */}
                                        </div>
                                    </div>
                                }
                                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "4339") &&
                                    <div className="horse">
                                        <div className="sub_path center-box">
                                            <p>Grayhound Racing</p>
                                        </div>
                                        <div className="game-wrap col3  py-1 d-flex">
                                            {this.state.houndEvents.length !== 0 && <span className='upcome'>Coming Up</span>}

                                            {this.state.houndEvents.length === 0 &&
                                                <span style={{ margin: "5px", width: 300 }}>has no live event.</span>
                                            }
                                            <ScrollContainer className="scroll-container" horizontal="true" vertical="false">
                                                <div style={{ whiteSpace: "nowrap" }}>
                                                    <ul className='horsedatahome'>
                                                        {this.state.houndEvents.map((ev, i) => {
                                                            if (this.state.filter === "multi" && this.state.pinnedEvents.indexOf(ev.catalogue.marketId) === -1) {
                                                                return false
                                                            }
                                                            if (this.state.filter === "tv" && ev.metadata.eventMeta.hasTv !== 'true') {
                                                                return false
                                                            }
                                                            return <li>
                                                                <a onClick={() => { this.props.history.push("/event/" + ev.eventType.id + "/" + ev.event.id + "/" + ev.catalogue.marketId) }}>
                                                                    <img src={BASE_IMAGE_PATH + "/casino/banner/images/dog.svg"} className='horsehomeimg'></img>
                                                                    <span className='mr-1'>{this.formatTimeString(ev.catalogue.marketTime)}</span>{ev.event.name}
                                                                </a>
                                                            </li>
                                                        })}
                                                    </ul>
                                                </div>
                                            </ScrollContainer>
                                            {/* <marquee scrollamount="5" behavior="scroll" className="horsemarquee">
                                                <ul className='horsedatahome'>
                                                    {this.state.houndEvents.map((ev, i) => {
                                                        if (this.state.filter === "multi" && this.state.pinnedEvents.indexOf(ev.catalogue.marketId) === -1) {
                                                            return false
                                                        }
                                                        if (this.state.filter === "tv" && ev.metadata.eventMeta.hasTv !== 'true') {
                                                            return false
                                                        }
                                                        return <li>
                                                            <a onClick={() => { this.props.history.push("/event/" + ev.eventType.id + "/" + ev.event.id + "/" + ev.catalogue.marketId) }}>
                                                                <img src={BASE_IMAGE_PATH + "/casino/banner/images/dog.svg"} className='horsehomeimg'></img>
                                                                <span className='mr-1'>{this.formatTimeString(ev.catalogue.marketTime)}</span>{ev.event.name}
                                                            </a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </marquee> */}
                                        </div>
                                    </div>
                                }

                                {!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && ((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "400") && <InPlayGame history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} notify={(msg, type) => { this.props.notify(msg, type) }} filter={this.state.filter} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents} gameCode={"400"} selected_game_code={this.state.selected_game_code} selected_event_code={this.state.selected_event_code} betForm={(game, event, clicked) => { this.betForm(game, event, clicked) }} game={this.state.kbdEvents} addBet={(data, event) => { this.addBet(data, event) }} game_name={"Kabaddi"} togglebetLoader={()=>this.setState({loadingBet: true})} />}
                                {!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && ((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "500") && <InPlayGame history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} notify={(msg, type) => { this.props.notify(msg, type) }} filter={this.state.filter} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents} gameCode={"500"} selected_game_code={this.state.selected_game_code} selected_event_code={this.state.selected_event_code} betForm={(game, event, clicked) => { this.betForm(game, event, clicked) }} game={this.state.electEvents} addBet={(data, event) => { this.addBet(data, event) }} game_name={"Election"} togglebetLoader={()=>this.setState({loadingBet: true})} />}
                                {showBinary && ((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.filter === "all" || this.state.filter === "multi" || this.state.filter === "tv" || this.state.filter === "300") && <InPlayGame history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} notify={(msg, type) => { this.props.notify(msg, type) }} filter={this.state.filter} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents} gameCode={"300"} selected_game_code={this.state.selected_game_code} selected_event_code={this.state.selected_event_code} betForm={(market, bet, clicked) => { this.betFormBin(market, bet, clicked) }} game={this.state.binaryEvents} addBet={(data) => { this.addBetBin(data) }} game_name={"Binary"} />}
                            </div>
                            <div className="live-match livetv">
                                <div className="center-box mt-1">
                                    <div className="container-fluid titbg">
                                        <div className="w-100 float-left">
                                            <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                            {this.state.matched_bet.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                        </div>
                                    </div>
                                    {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.matched_bet.map((bet, i) => {
                                                    if (i >= this.state.betLimit) {
                                                        return false
                                                    }

                                                    if (bet.eventTypeId === '300') {
                                                        bet.market_time = dateUtil.getBinaryMarketDisplayName(bet.marketName)
                                                    }
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            {
                                                                bet.eventTypeId === '300' ?
                                                                    <td>{!!bet.market_time && bet.market_time.length > 0 ?
                                                                        <>
                                                                            {bet.market_time[0]}
                                                                            <small className='float-right'><b>[{bet.market_time[1]}]</b></small>
                                                                        </>

                                                                        : !!bet.marketName ? bet.marketName : "-"}</td>
                                                                    :
                                                                    <td>{bet.runnerName + " - " + bet.marketName}</td>
                                                            }
                                                            <td>{bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                    {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.unmatched_bet.map((bet) => {
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.runnerNam + " - " + bet.marketNamee}</td>
                                                            <td>{bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
                        <div className="sub_path over-wrap">
                            <div className="center-box ">
                                <div className="container-fluid titbg">
                                    <div className="w-100 float-left">
                                        <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                        {this.state.matched_bet.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                    </div>
                                </div>
                                {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.matched_bet.map((bt, i) => {
                                                let bet = bt
                                                if (i >= this.state.betLimit) {
                                                    return false
                                                }
                                                if (bet.eventTypeId === '300') {
                                                    bet.market_time = dateUtil.getBinaryMarketDisplayName(bet.marketName)
                                                }
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        {
                                                            bet.eventTypeId === '300' ?
                                                                <td>{!!bet.market_time && bet.market_time.length > 0 ?
                                                                    <>
                                                                        {bet.market_time[0]}
                                                                        <small className='float-right'><b>[{bet.market_time[1]}]</b></small>
                                                                    </>

                                                                    : !!bet.marketName ? bet.marketName : "-"}</td>
                                                                :
                                                                <td>{bet.runnerName + " - " + bet.marketName}</td>
                                                        }
                                                        <td>{bet.eventTypeId === "300" ? bet.runnerId : bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                                {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.unmatched_bet.map((bet) => {
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        <td>{bet.runnerName + " - " + bet.marketName}</td>
                                                        <td>{bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}

                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    {this.state.betSlipOpen && <BetSlipPopup bets={this.state.matched_bet} hidePopup={() => { this.hidePopup() }} />}
                </div>

            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(InPLay);